import React, { useRef, useState, useEffect, useMemo } from "react";
import { createAndResizeCircImgDivs } from "../scripts/resizer";
import Modal from "./Modal";
import visionIcon1 from "../assets/images/1_Intro/intro_vision_icon1.svg";
import visionIcon2 from "../assets/images/1_Intro/intro_vision_icon2.svg";
import visionIcon3 from "../assets/images/1_Intro/intro_vision_icon3.svg";
import visionIcon4 from "../assets/images/1_Intro/intro_vision_icon4.svg";
import visionC1 from "../assets/images/1_Intro/intro_vision_1c.png";
import visionC2 from "../assets/images/1_Intro/intro_vision_2c.png";
import visionC3 from "../assets/images/1_Intro/intro_vision_4c.png";
import visionC4 from "../assets/images/1_Intro/intro_vision_6c.png";
import nextStepsIcon1 from "../assets/images/5_Next Stops/nextstops_nextsteps_icon1.svg"
import nextStepsIcon2 from "../assets/images/5_Next Stops/nextstops_nextsteps_icon2.svg";
import nextStepsIcon3 from "../assets/images/5_Next Stops/nextstops_nextsteps_icon3.svg";
import hdrBefore from "../assets/images/1_Intro/intro_vision_before_photo.jpg";
import hdrAfter from "../assets/images/1_Intro/intro_vision_after_photo.jpg";


const ScrollSection = ({ handleOpenModal, handleCloseModal, id, tabs, onRendered }) => {
    const modalShowing = useRef(false);
    const afterImageRef = useRef(null);
    const sliderRef = useRef(null);
    const tabListRef = useRef(null);
    const tabRefs = useMemo(() => Array(tabs).fill().map(() => React.createRef()), [tabs]);
    const sectionRefs = useMemo(() => Array(tabs).fill().map(() => React.createRef()), [tabs]);
    const [sliderPosition, setSliderPosition] = useState(50);
    const [activeTab, setActiveTab] = useState(0);
    const navBarHeight = 80; // Adjust this value to match the height of your NavBar component
    const styles = {
        imageStyle: {
            maxWidth: '8000%',
            padding: '0 !important',
            width: '100%'
        }
    };

    useEffect(() => {
        createAndResizeCircImgDivs();
        if (onRendered) onRendered(); // Notify parent component

        const handleMouseMove = (e) => {
            const rect = afterImageRef.current.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const newPosition = Math.max(0, Math.min(offsetX, rect.width));
            setSliderPosition((newPosition / rect.width) * 100); // Convert to percentage
        };

        const handleTouchMove = (e) => {
            const rect = afterImageRef.current.getBoundingClientRect();
            const offsetX = e.touches[0].clientX - rect.left;
            const newPosition = Math.max(0, Math.min(offsetX, rect.width));
            setSliderPosition((newPosition / rect.width) * 100); // Convert to percentage
        };

        const slider = sliderRef.current;
        if (slider) {
            slider.addEventListener('mousedown', () => {
                document.addEventListener('mousemove', handleMouseMove);
            });
            slider.addEventListener('touchstart', () => {
                document.addEventListener('touchmove', handleTouchMove);
            });
            document.addEventListener('mouseup', () => {
                document.removeEventListener('mousemove', handleMouseMove);
            });
            document.addEventListener('touchend', () => {
                document.removeEventListener('touchmove', handleTouchMove);
            });
        }
        
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseMove);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchMove);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const tabList = tabListRef.current;
            const tabListTop = tabList.getBoundingClientRect().top;
            const fixedClass = "fixed";
            if (tabs === 4) {
                const sectionTop0 = sectionRefs[0].current.getBoundingClientRect().top + 80;
                const sectionTopLast = sectionRefs[tabs - 1].current.getBoundingClientRect().top + 80;
                if (tabListTop <= 110 && sectionTop0 <= 110 && sectionTopLast > -40) {
                    tabList.classList.add(fixedClass);
                } else {
                    tabList.classList.remove(fixedClass);
                }
                sectionRefs.forEach((ref, index) => {
                    const sectionTop = ref.current.getBoundingClientRect().top;
                    if (sectionTop <= 110 && sectionTop >= -ref.current.offsetHeight / 2 - 80) {
                        setActiveTab(index);
                    }
                });
            } else if (tabs === 3) {
                const sectionTop0 = sectionRefs[0].current.getBoundingClientRect().top + 80;
                const sectionTopLast = sectionRefs[tabs - 1].current.getBoundingClientRect().top + 80;
                if (tabListTop <= 110 && sectionTop0 <= 110 && sectionTopLast > -110) {
                    tabList.classList.add(fixedClass);
                } else {
                    tabList.classList.remove(fixedClass);
                }
                sectionRefs.forEach((ref, index) => {
                    const sectionTop = ref.current.getBoundingClientRect().top;
                    if (sectionTop <= 160 && sectionTop >= -ref.current.offsetHeight / 2) {
                        setActiveTab(index);
                    }
                });
            };
        };
        
        handleScroll();

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [sectionRefs, tabs]);
    
    const handleTabClick = (index) => {
        const currentTab = sectionRefs[index].current;
        const section = currentTab.parentElement;
        console.log(section, currentTab);
        if (activeTab > index) {
            const scrollTop = currentTab.getBoundingClientRect().top + navBarHeight;
            console.log("scrolling up", scrollTop);
            currentTab.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        } else {
            const scrollTop = currentTab.getBoundingClientRect().top - navBarHeight;
            console.log("scrolling down", scrollTop);
            currentTab.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        }
        setActiveTab(index);
    };
    

    const handleKeyDown = (event, index) => {
        const key = event.key;
        if (key === "Enter" || key === " ") {
            event.preventDefault();
            handleTabClick(index);
        } else if (key === "ArrowLeft") {
            event.preventDefault();
            const newIndex = index === 0 ? tabRefs.length - 1 : index - 1;
            tabRefs[newIndex].current.focus();
        } else if (key === "ArrowRight") {
            event.preventDefault();
            const newIndex = index === tabRefs.length - 1 ? 0 : index + 1;
            tabRefs[newIndex].current.focus();
        } else if (key === "Home") {
            event.preventDefault();
            tabRefs[0].current.focus();
        } else if (key === "End") {
            event.preventDefault();
            tabRefs[tabRefs.length - 1].current.focus();
        }
    };

    const handleOpenModalWithState = (modalId) => {
        handleOpenModal(modalId);
        modalShowing.current = true;
        document.querySelector("body").classList.add("hdr-modal-showing");
    };

    const handleCloseModalWithState = (modalId) => {
        handleCloseModal(modalId);
        modalShowing.current = false;
        document.querySelector("body").classList.remove("hdr-modal-showing");
    };

    if (id === 'our-vision') {
        return (
            <div className="row blue-bg" id="our-vision">
                <div className="col-md-12">
                    <h2>Our goals</h2>

                    <p>The 20-Year Needs Assessment is a broad, comprehensive blueprint that outlines the MTA region's transportation capital needs for the next generation. It provides an extensive, long-term view based upon rigorous data analysis across all the MTA agencies. It's also an opportunity to look beyond today's constraints to envision the possible future of the system if the right investments are made.</p>
                    <div className="hdr-tabs vision-box vision-sextet">
                        <div className="hdr-tablist" role="tablist" ref={tabListRef}>
                            <button className="hdr-tab" type="button" aria-selected={activeTab === 0} role="tab" ref={tabRefs[0]} onClick={() => handleTabClick(0)} onKeyDown={(e) => handleKeyDown(e, 0)}><span>Rebuild our system so it will last another 100 years</span></button>
                            <button className="hdr-tab" type="button" aria-selected={activeTab === 1} role="tab" ref={tabRefs[1]} onClick={() => handleTabClick(1)} onKeyDown={(e) => handleKeyDown(e, 1)} tabIndex="-1"><span>Create additional capacity where it is needed most</span></button>
                            <button className="hdr-tab" type="button" aria-selected={activeTab === 2} role="tab" ref={tabRefs[2]} onClick={() => handleTabClick(2)} onKeyDown={(e) => handleKeyDown(e, 2)} tabIndex="-1"><span>Make the system more accessible to all</span></button>
                            <button className="hdr-tab" type="button" aria-selected={activeTab === 3} role="tab" ref={tabRefs[3]} onClick={() => handleTabClick(3)} onKeyDown={(e) => handleKeyDown(e, 3)} tabIndex="-1"><span>Accelerate the fight against climate change</span></button>
                        </div>
                    
                        <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 0} id="hdr-tabpanel-1" ref={sectionRefs[0]}>
                            <div className="row">
                                <div className="col-md-8">
                                    <img src={visionIcon1} alt="" aria-hidden="true" />
                                    <h3>Rebuild our system so it will last another 100 years</h3>
                                    <ul className="check-list">
                                        <li>Replace antiquated signals, switches, and interlockings&mdash;on subways and on commuter railroads&mdash;that contribute to lengthy delays and upgrade our power systems to meet our needs into the future.</li>
                                        <li>Reconstruct the crumbling infrastructure that leads to Grand Central, avoiding catastrophic shutdown of Metro-North Railroad (Metro-North) service.</li>
                                        <li>Continue to rebuild our 200-year-old Long Island Rail Road (LIRR), especially tunnels, to maintain Brooklyn service.</li>
                                        <li>Use innovative technology like dehumidifying our bridge cables on the Verrazzano-Narrows Bridge to extend its useful life.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <img src={visionC1} style={styles.imageStyle} alt="" aria-hidden="true" />
                                </div>
                            </div>
                        </div>
                    
                        <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 1} ref={sectionRefs[1]}>
                            <div className="row">
                                <div className="col-md-8">
                                    <img src={visionIcon2} alt="" aria-hidden="true" />
                                    <h3>Create additional capacity where it is needed most</h3>
                                
                                    <ul className="check-list">
                                        <li>Install modern signals across 80% of the subway system to allow us to safely run more trains closer together and improve on-time performance.</li>
                                        <li>Make capacity improvements for LIRR customers that allow for increased speeds through the Jamaica complex, saving riders up to three minutes per day and enabling more predictable track assignments and transfers.</li>
                                        <li>Enable more scheduled trains for Metro-North riders, through implementing Penn Access, upgrading signals and power, and planning for capacity improvements.</li>
                                        <li>Make the subway and commuter rail system convenient to more riders by building connections between neighborhoods by advancing new projects like the Interborough Express (IBX).</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <img src={visionC2} style={styles.imageStyle} alt="" aria-hidden="true" />
                                </div>
                            </div>
                        </div>

                        <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 2} ref={sectionRefs[2]}>
                            <div className="row">
                                <div className="col-md-8">
                                    <img src={visionIcon4} alt="" aria-hidden="true" />
                                    <h3>Make the system more accessible to all</h3>
                        
                                    <ul className="check-list">
                                        <li>Continue investing in ADA accessibility projects to ensure that, by 2045, 90% of all subway rides take place at fully ADA accessible stations.</li>
                                        <li>Make 95% of commuter rail stations accessible by 2045.</li>
                                        <li>Make MTA bridges more accessible to pedestrians and cyclists.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <img src={visionC3} style={styles.imageStyle} alt="" aria-hidden="true" />
                                </div>
                            </div>
                        </div>

                        <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 3} ref={sectionRefs[3]}>
                            <div className="row">
                                <div className="col-md-8">
                                    <img src={visionIcon3} alt="" aria-hidden="true" />
                                    <h3>Accelerate the fight against climate change</h3>
                        
                                    <ul className="check-list">
                                        <li>Ensure the system is ready for all kinds of extreme weather&mdash;all subway stations, railroad lines, and critical infrastructure will be protected from climate threats.</li>
                                        <li>Cut the MTA's operational greenhouse gas emissions at least 85% by converting nearly 6,000 MTA buses to zero-emissions, retrofitting existing facilities, investing in energy-saving technologies, and more.</li>
                                    </ul>
                                </div>
                                <div className="col-md-4">
                                    <img src={visionC4} style={styles.imageStyle} alt="" aria-hidden="true" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3>A look at two possible tomorrows</h3>

                    <div className="row">
                        <div className="col-sm-9">
                            <div className="hdr-before-after" id="hdr-before-after">
                                <img src={hdrBefore} alt="Before and after slider" />
                                <div className="hdr-after-image" id="hdr-after-image" ref={afterImageRef} style={{ clipPath: `inset(0 0 0 ${sliderPosition}%)` }}>
                                    <img src={hdrAfter} alt="" aria-hidden="true" id="hdr-after-image-img" />
                                </div>
                                <button id="hdr-ba-button" ref={sliderRef} style={{ left: `${sliderPosition}%` }}>
                                    <span className="ada-element">Show future image with arrow keys</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <p><em>Use the slider to envision a system without proper investment (left) and with proper investment (right).</em></p>
                            
                            <p><a className="hdr-launch-modal plus-sign" rel="noreferrer"
                                        onClick={() => handleOpenModalWithState("more-info-future")}>Explore a future with proper investment</a></p>
                            <Modal
                                id="more-info-future"
                                title="A future with proper investment"
                                content={
                                    <div className="hdr-modal-body">
                                        <div className="row">
                                            <img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/9a735932-8507-4d4d-6b1a-e2cb5401c500/width=2000" alt="" aria-hidden="true">
                                            </img>
                                        </div>
                                    </div>
                                }
                                imageSrc="	https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/f1744977-dfdd-4edf-4844-b7f6e4a04400/width=2000"
                                onClose={() => handleCloseModalWithState("more-info-future")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return(
            <div className="row blue-bg" id={id}>
                <h2 className="set-p3">Keys to success</h2>

                <p>Over the course of the next year, in collaboration with our regional partners, we will take this 20-Year Needs Assessment and use it to guide the creation of a five-year capital plan. In order to begin translating these needs and opportunities into an initial set of concrete projects, we will consider the system's needs holistically and identify opportunities to bundle projects together to create the most efficient and cost-effective approach. The five-year capital plan will be presented on Oct. 1, 2024.</p>

                <h3 className="style-h4">Success will depend on resources</h3>

                <p>Our ability to address the needs identified in the 20-Year Needs Assessment will depend on the resources we have available. These include:</p>
                <div className="hdr-tabs vision-box">
                    <div className="hdr-tablist" role="tablist" ref={tabListRef}>
                        <button className="hdr-tab" type="button" aria-selected={activeTab === 0} role="tab" ref={tabRefs[0]} onClick={() => handleTabClick(0)} onKeyDown={(e) => handleKeyDown(e, 0)}><span>Sufficient funding</span></button>
                        <button className="hdr-tab" type="button" aria-selected={activeTab === 1} role="tab" ref={tabRefs[1]} onClick={() => handleTabClick(1)} onKeyDown={(e) => handleKeyDown(e, 1)} tabIndex="-1"><span>Strong partnerships</span></button>
                        <button className="hdr-tab" type="button" aria-selected={activeTab === 2} role="tab" ref={tabRefs[2]} onClick={() => handleTabClick(2)} onKeyDown={(e) => handleKeyDown(e, 2)} tabIndex="-1"><span>Make the system more accessible to all</span></button>
                    </div>
                    <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 0} id="hdr-tabpanel-1" ref={sectionRefs[0]}>
                        <div className="row">
                            <div className="col-md-8">
                                <img src={nextStepsIcon1} alt="" aria-hidden="true" />
                                <h3>Sufficient funding</h3>
                                <p>The vision that we establish for our system relies on adequate&mdash;and timely&mdash;funding. Without this support from our critical partners in the city, state, and federal government, we will not be able to meet the ambitious goals we have set for ourselves.</p>
                                        
                                <p>Different funding scenarios will yield different results. Our top priority must be rebuilding the critical aging infrastructure at risk for catastrophic breakdown without intervention.</p>
                                
                                <p>A low funding scenario would require us to spend the vast majority of our resources on these urgent projects, with far less funding available for improving and expanding the system.</p>
                            </div>
                            <div className="col-md-4">
                                <img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/7280d592-ade7-48f1-3cd8-4f3fdab3a800/public" className="circ-img full-width" alt="" aria-hidden="true" />
                            </div>
                        </div>
                    </div>
            
                <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 1} ref={sectionRefs[1]}>
                    <div className="row">
                        <div className="col-md-8">
                            <img src={nextStepsIcon2} alt="" aria-hidden="true" />
                            <h3>Strong partnerships</h3>
                        
                            <p>In addition to funding partnerships with the city, state, and federal government, we must also work together to ensure the system's success.</p>
                                    
                                    <p>Our construction projects require close coordination and collaboration with local planning and transportation departments, utility companies, local businesses, and residents. By working efficiently and collaboratively, we can minimize costs, reduce red tape, and deliver benefits to the region.</p>
                                    
                                    <p>We also depend on our partners to keep the system running smoothly. Stormwater is managed separately by each municipality. The future of the MTA depends on long-term planning by the relevant municipalities to reduce the threat of flooding. Con Edison provides the electrical capacity for us to transition our bus fleets to more sustainable designs and the power we need to keep our subways and trains running.</p>
                                    
                                    <p>Successful collaborations can also yield major breakthroughs, like when the MTA and the New York City Department of City Planning worked together in 2021 on a zoning amendment that offers developers building over subway stations a density bonus if they fund accessibility upgrades. Industry partnerships are also creating jobs, building capacity in the system, and encouraging innovation.</p>
                                    
                                    <p>These kinds of creative partnerships will be crucial to achieving the goals we share for our system.</p>
                            </div>
                            <div className="col-md-4">
                                    <img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/031dd64e-6594-4f18-3f6e-732b1fd17600/public" className="circ-img full-width" alt="" aria-hidden="true" />
                            </div>
                    </div>
                </div>

                <div className="hdr-tabpanel" role="tabpanel" aria-hidden={activeTab !== 2} ref={sectionRefs[2]}>
                    <div className="row">
                        <div className="col-md-8">
                            <img src={nextStepsIcon3} alt="" aria-hidden="true" />
                            <h3>Public Engagement and Support</h3>
                
                            <p>Our work is done to benefit the public&mdash;so that the trains, buses, bridges, and tunnels the public relies on continue to be there for them. That construction work, though, can be disruptive, especially in old and constrained spaces. We need the public to be patient as we get past short-term disruptions in order to generate long-term benefits.</p>
                                    
                            <p>But it's not enough to simply expect that of riders. We will continue to do our part, communicating directly and honestly with customers about impacts, and, just as crucially, helping them understand the reasons we're doing the work in the first place. This partnership&mdash;between us and our riders&mdash;is absolutely essential to delivering on the promise of this plan. Our partners in the advocacy community, at organizations both large and small, will be essential in forging this link.</p>
                        </div>
                        <div className="col-md-4">
                            <img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/bf9fd145-a3d2-4433-e73c-b21921473b00/public" className="circ-img full-width" alt="" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    };
};

export default ScrollSection;